import type { AccountStatus, ProviderInfo } from "./accountLinkPort.js";

export function deriveAccountStatus(providerData: readonly ProviderInfo[]): AccountStatus {
  const candidates = providerData.filter((p) => p.providerId !== "firebase");
  const chosen = candidates.find((p) => p.providerId === "google.com") ?? candidates[0];
  if (!chosen) return { linked: false };
  return {
    linked: true,
    provider: chosen.providerId,
    email: chosen.email ?? undefined,
    displayName: chosen.displayName ?? undefined,
  };
}
